var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.608 22.708C16.404 22.708 16.234 22.64 16.098 22.504L6.204 12.61C6.068 12.474 6 12.304 6 12.1C6 11.896 6.068 11.726 6.204 11.59L16.098 1.69599C16.234 1.58265 16.3927 1.53732 16.574 1.55999C16.7553 1.55999 16.914 1.62799 17.05 1.76399C17.186 1.87732 17.254 2.02465 17.254 2.20599C17.2767 2.38732 17.2313 2.54599 17.118 2.68199L7.7 12.1L17.118 21.518C17.2087 21.6313 17.2653 21.756 17.288 21.892C17.3107 22.028 17.288 22.164 17.22 22.3C17.1747 22.4133 17.0953 22.5153 16.982 22.606C16.8687 22.674 16.744 22.708 16.608 22.708Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.b329ca882f28836a8e4217daa9b5bec3.svg";
export { ForwardRef as ReactComponent };